import { useEffect } from 'react';

const ConnectRedirect = () => {
  useEffect(() => {
    window.location.href = 'https://thelostloft.com';
  }, []);

  return null; // Component won't render due to redirect
};

export default ConnectRedirect;
